import { AxiosInstance } from "axios";
import { type ICore } from "./interfaces";

export function updateUserAddressBuilder(apiClient: AxiosInstance) {
  return async function updateUserAddress(
    addressId: string,
    payload: ICore.SaveAddressRequestDto,
  ): Promise<any> {
    const response = await apiClient.put(
      `/accounts/user-addresses/${addressId}/`,
      payload,
    );
    return response.data;
  };
}
